angular.module('elogbooksServices')
    .service('lightBoxModal', ['$uibModal','apiClient', function ($uibModal) {
        return {
            open: function (modalData, config) {
                return $uibModal.open({
                    templateUrl: '/modules/common/modals/lightBox/lightbox.html',
                    controller: 'LightBoxModalController',
                    controllerAs: 'vm',
                    // Both modes are vertically centered; only image lightboxes size
                    // themselves to the image, the arbitrary template mode keeps the
                    // stock modal width
                    windowClass: config && config.template
                        ? 'lightbox-modal--centered'
                        : 'lightbox-modal lightbox-modal--centered',
                    resolve: {
                        config: function () {
                            var defaultConfig = {
                                titleMessage: 'ARE_YOU_SURE_HEADER',
                                bodyMessage: 'ARE_YOU_SURE',
                                primaryText: 'YES',
                                primaryClass: 'btn-danger',
                                secondaryText: 'NO',
                                secondaryClass: 'btn-default'
                            };

                            return angular.extend({}, defaultConfig, config);
                        },
                        modalData: function(){
                            return modalData;
                        }
                    }
                });
            }
        };
    }]);
